if (!customElements.get('music-box-story')) {
  class MusicBoxStory extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.videos = Array.from(this.querySelectorAll('video'));
      this.manualPauses = new Set();
      this.inView = new Set();
      this.listeners = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.listeners.signal };

      this.videos.forEach((video) => {
        video.muted = true;
        const button = video.parentElement.querySelector('[data-video-toggle]');
        const labels = {
          play: button.dataset.playLabel || 'Play',
          pause: button.dataset.pauseLabel || 'Pause',
          retry: button.dataset.retryLabel || 'Retry',
        };
        const updateLabel = () => {
          const action = video.paused ? 'play' : 'pause';
          button.querySelector('[data-video-label]').textContent = labels[action];
          button.setAttribute('aria-label', button.dataset[`${action}Aria`] || `${labels[action]} video: ${video.getAttribute('aria-label')}`);
        };
        button.addEventListener('click', () => {
          if (video.paused) {
            this.manualPauses.delete(video);
            this.play(video, true);
          } else {
            this.manualPauses.add(video);
            video.pause();
          }
        }, options);
        video.addEventListener('play', updateLabel, options);
        video.addEventListener('pause', updateLabel, options);
        video.addEventListener('error', () => {
          button.querySelector('[data-video-label]').textContent = labels.retry;
          button.setAttribute('aria-label', button.dataset.retryAria || `${labels.retry} video: ${video.getAttribute('aria-label')}`);
        }, options);
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) {
              this.inView.add(target);
              this.play(target);
            } else {
              this.inView.delete(target);
              target.pause();
            }
          });
        }, { threshold: 0.25 });
        this.videos.forEach((video) => this.observer.observe(video));
      }

      this.details.addEventListener('toggle', () => this.syncPlayback(), options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      this.motion.addEventListener('change', () => this.syncPlayback(), options);
      document.addEventListener('shopify:block:select', (event) => {
        if (event.detail.blockId === this.dataset.blockId) this.details.open = true;
      }, options);
    }

    play(video, userInitiated = false) {
      if (!this.details.open || document.hidden) return;
      if (!userInitiated && (this.motion.matches || navigator.connection?.saveData || this.manualPauses.has(video))) return;
      const source = video.querySelector('source[data-src]');
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        video.load();
      }
      const request = video.play();
      if (request) request.catch(() => {});
    }

    syncPlayback() {
      this.videos.forEach((video) => {
        if (this.details.open && !document.hidden && !this.motion.matches && this.inView.has(video)) {
          this.play(video);
        } else {
          video.pause();
        }
      });
    }

    disconnectedCallback() {
      this.videos.forEach((video) => video.pause());
      this.observer?.disconnect();
      this.listeners?.abort();
    }
  }
  customElements.define('music-box-story', MusicBoxStory);
}
